import { render, staticRenderFns } from "./inicio.vue?vue&type=template&id=283c4f77&scoped=true&"
var script = {}
import style0 from "./inicio.vue?vue&type=style&index=0&id=283c4f77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283c4f77",
  null
  
)

export default component.exports